import NOTI_PROMOTION_SKT from '../../../assets/images/components/notiPreReg/NOTI_PROMOTION_SKT.png';
import NOTI_PROMOTION_KT from '../../../assets/images/components/notiPreReg/NOTI_PROMOTION_KT.png';
import NOTI_PROMOTION_LGU from '../../../assets/images/components/notiPreReg/NOTI_PROMOTION_LGU.png';
import BANNER_IMG from '../../../assets/images/banner/banner-noti2@2x.png';
import TERM_NOTI_PROMOTION from '../terms/TERM_NOTI_PROMOTION';
export const DESCRIPTION = [
  {
    title: '프로모션 및 경품 안내사항',
    caption: [
      '· 본 프로모션은 비정상적인 방법으로 참여하시면 경품에 당첨되더라도 취소될 수 있고, 제공해 드린 혜택이 무효가 될 수 있습니다.',
      '· 본 프로모션의 기간은 회사 및 제휴사 사정에 따라 기간, 내용 등이 변경되거나 일찍 종료될 수 있습니다.',
      '· 본 프로모션의 경품 이미지는 이해를 돕기 위한 것이며, 변경될 수 있습니다.',
      '· 본 프로모션의 경품이 5만 원을 초과하는 경우, 경품에 대한 제세 공과금(경품 판매 금액의 22%)는 고객의 부담입니다.',
      '· 본 프로모션의 경품 발송 안내는 프로모션 종료 후 1달 안에 정기 알림 서비스 신청 시 입력된 휴대폰 번호로 안내될 예정입니다. 만일, 3회 이상 연락이 되지 않거나 개인정보가 확인되지 않을 경우 경품 지급이 취소됩니다.',
    ],
  },
];

const PROMOTION: any = {
  skt: null,
  kt: {
    CONTENT_IMG: NOTI_PROMOTION_KT,
    BANNER: BANNER_IMG,
    DESCRIPTION,
    TERM: TERM_NOTI_PROMOTION,
    start: '20230306000000',
    end: '20230331235959',
  },
  lgu: {
    CONTENT_IMG: NOTI_PROMOTION_LGU,
    BANNER: BANNER_IMG,
    DESCRIPTION,
    TERM: TERM_NOTI_PROMOTION,
    start: '20230306000000',
    end: '20230331235959',
  },
};

export default PROMOTION;
